






































































































import {
  Component,
  Prop,
  PropSync,
  Ref,
  Vue,
  Watch
} from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import userStore from '@/modules/auth/auth.store'
import ServerError from '@/utils/server_error'
import {
  ResponseStatus,
  TournamentAPI,
  TournamentEntity,
  TournamentState
} from '@/api/tournament'
import {
  CheckInRoleType,
  MatchAPI,
  MatchGameEntity,
  MatchGameState,
  RelatedTournament
} from '@/api/match'
import { TournamentTeamState } from '@/api/tournamentTeam'

@Component
export default class JoinableMatchJoinedTournamentCard extends Vue {
  userModule = getModule(userStore, this.$store)
  @PropSync('visible', { required: true }) isVisible!: boolean
  @Prop({ required: true }) tournamentId!: string
  @Prop({ required: true }) tournamentName!: string
  @Prop({ default: '' }) tournamentLogo!: string
  @Prop({ required: true }) tournamentState!: TournamentState
  @Prop({ required: true }) isAutomated!: boolean
  @Prop({ required: true }) teamState!: TournamentTeamState
  @Prop({ default: '' }) scheduleStart!: string
  @Prop({ default: false }) isTeamStarter!: boolean

  @Ref('card')
  readonly card!: HTMLDivElement

  @Watch('isVisible')
  async onVisibleChanged(isVisible: boolean) {
    if (isVisible) {
      window.addEventListener('click', this.onClickOutside)
    } else {
      window.removeEventListener('click', this.onClickOutside)
    }
    setTimeout(this.updateLayout)
  }

  get isCurrentRoute() {
    return this.$route.params.tournamentId === this.tournamentId
  }

  async onViewTournamentClicked() {
    if (this.isAutomated) {
      await this.$router.push({
        name: 'AutomatedTournament'
      })
    } else {
      await this.$router.push({
        name: 'TournamentDetailsOverview',
        params: {
          tournamentId: this.tournamentId
        }
      })
    }

    this.$emit('close')
  }

  /* Computed Properties */
  get TournamentState() {
    return TournamentState
  }

  get TeamState() {
    return TournamentTeamState
  }

  get isOpenRegistration() {
    return this.tournamentState === TournamentState.OpenRegistration
  }

  get isCompletedRegistration() {
    return this.tournamentState === TournamentState.CompleteRegistration
  }

  get isInProgress() {
    return this.tournamentState === TournamentState.InProgress
  }

  get isPendingJoin() {
    return this.teamState === TournamentTeamState.PendingJoin
  }

  get isPendingConfirmRoster() {
    return this.teamState === TournamentTeamState.PendingConfirmRoster
  }

  get isRegistered() {
    return this.teamState === TournamentTeamState.Registered
  }

  get scheduleStartMoment() {
    return this.$moment(parseInt(this.scheduleStart) * 1000).format(
      'YYYY/MM/DD hh:mm:ss A'
    )
  }

  /* Methods */
  onClickOutside(e: MouseEvent) {
    if (!this.card) return
    const children = this.card.getElementsByTagName('*')

    for (const child of children) {
      if (child === e.target) {
        return
      }
    }

    this.$emit('close')
  }

  updateLayout() {
    if (!this.card) {
      return
    }
    const bottomBarHeight = 60

    if (
      this.card.offsetTop + this.card.clientHeight >=
      window.innerHeight - bottomBarHeight
    ) {
      // use screen bottom as anchor
      this.card.style.top =
        'calc(-' + (window.innerHeight - bottomBarHeight) + 'px - 4rem)'
    }
  }
}
